/**
 * Created by Viacheslav Stepanian on 21.04.2026
 */

cleverapps.InitByFeature["alternative_hard"] = function () {
    if (!connector.platform.oneOf(connector.ARKADIUM) && !cleverapps.gameModes.alternativeHard) {
        return;
    }

    const prefix = "alternative_";

    const original = Messages._findInDictionaries.bind(Messages);
    Messages._findInDictionaries = function (code) {
        return original(`${prefix}${code}`) || original(code);
    };

    Object.keys(bundles).forEach((bundleName) => {
        ["frames", "jsons", "urls"].forEach((category) => {
            Object.keys(bundles[bundleName][category] || {}).forEach((key) => {
                if (key.indexOf(prefix) !== 0) {
                    return;
                }

                const existing = bundles[bundleName][category][key.slice(prefix.length)];
                if (existing) {
                    Object.assign(existing, bundles[bundleName][category][key]);
                } else {
                    bundles[bundleName][category][key.slice(prefix.length)] = bundles[bundleName][category][key];
                }
            });
        });
    });

    const PRODUCT_OVERRIDES = {
        gold500: { title: "Shop.Gold500.Title", description: "Shop.Gold500.Description", image: true },
        gold1800: { title: "Shop.Gold1800.Title", description: "Shop.Gold1800.Description", image: true },
        gold3800: { title: "Shop.Gold3800.Title", description: "Shop.Gold3800.Description", image: true },
        gold6000: { title: "Shop.Gold6000.Title", description: "Shop.Gold6000.Description", image: true },
        gold25000: { title: "Shop.Gold25000.Title", description: "Shop.Gold25000.Description", image: true },
        hard2: { title: "Shop.Hard2.Title", description: "Shop.Hard2.Description", image: true },
        hard5: { title: "Shop.Hard5.Title", description: "Shop.Hard5.Description", image: true },
        hard10: { title: "Shop.Hard10.Title", description: "Shop.Hard10.Description", image: true },
        hard20: { title: "Shop.Hard20.Title", description: "Shop.Hard20.Description", image: true },
        hard45: { title: "Shop.Hard45.Title", description: "Shop.Hard45.Description", image: true },
        hard100: { title: "Shop.Hard100.Title", description: "Shop.Hard100.Description", image: true },
        expeditionPack: { title: "Shop.expeditionPack.title", description: "Shop.expeditionPack.description" }
    };

    const originalGetProduct = connector.payments.getProduct.bind(connector.payments);
    connector.payments.getProduct = function (productIdOrTag) {
        const product = originalGetProduct(productIdOrTag);
        if (!product || !product.itemId) {
            return product;
        }

        const override = PRODUCT_OVERRIDES[product.itemId];
        if (!override) {
            return product;
        }

        const title = Messages.get(override.title);
        const description = Messages.get(override.description);
        if (title !== override.title) {
            product.title = title;
        }
        if (description !== override.description) {
            product.description = description;
        }
        if (override.image && product.image) {
            product.image = product.image.replace(/\/([^/]+)$/, `/${prefix}$1`);
        }
        return product;
    };
};

cleverapps.InitByFeature["alternative_hard_debug"] = cleverapps.InitByFeature["alternative_hard"];
